import { Button, Popconfirm, Space, Typography, theme } from 'antd';
import { FC } from 'react';
import { ExclamationCircle, Trash } from 'react-bootstrap-icons';

import { CopyableText, DescriptionBlock, EmptyText, HiddenPassword } from '@/common/components';
import { CommonDrawerTitle } from '@/common/layouts';
import { capitalizeString } from '@/common/utils';

import { DnsRecord, DnsRecordsApiProviderTag } from '@/modules/DnsRecords';

interface Props {
  dnsRecord: DnsRecord;
  isDeleteDnsRecordLoading: boolean;
  isDeleteDnsRecordDisabled: boolean;
  handleDeleteDnsRecord: () => void;
}

const { Text } = Typography;

export const DnsRecordsOverviewView: FC<Props> = ({
  dnsRecord,
  isDeleteDnsRecordLoading,
  isDeleteDnsRecordDisabled,
  handleDeleteDnsRecord
}) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Popconfirm
              disabled={ isDeleteDnsRecordDisabled }
              title="Видалити цей DNS запис?"
              onConfirm={ handleDeleteDnsRecord }
              okType="danger"
              okText="Так"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              placement="bottomRight"
            >
              <Button loading={ isDeleteDnsRecordLoading } disabled={ isDeleteDnsRecordDisabled } danger icon={ <Trash/> }>
                Видалити
              </Button>
            </Popconfirm>
          </Space>
        }
      />

      <DescriptionBlock items={ [['Назва', dnsRecord.name]] }/>
      <DescriptionBlock
        items={ [
          [
            'NS записи',
            <div key="nses">
              { dnsRecord.records.map((record) => (
                <>
                  <CopyableText textToCopy={ record } key={ record }>
                    { record }
                  </CopyableText>
                  <br/>
                </>
              )) }
            </div>
          ]
        ] }
      />
      <DescriptionBlock
        items={ [
          [
            'API провайдер',
            dnsRecord.apiProvider ? <DnsRecordsApiProviderTag provider={ dnsRecord.apiProvider }/> : <EmptyText/>
          ]
        ] }
      />
      { dnsRecord.apiProvider && (
        <DescriptionBlock
          items={ [
            [
              `Акаунт ${ capitalizeString(dnsRecord.apiProvider) }`,
              <div key="dnsRecord.apiProvider.account">
                <CopyableText textToCopy={ dnsRecord.apiProviderAccount?.email ?? '' }>
                  <Text type="secondary">Логін:</Text>&nbsp;{ dnsRecord.apiProviderAccount?.email }
                </CopyableText>
                <br/>
                <HiddenPassword key="password" password={ dnsRecord.apiProviderAccount?.password ?? '' } label="Пароль"/>
              </div>
            ]
          ] }
        />
      ) }
    </>
  );
};
